<!-- 我的页面 -->
<template>
      <div class="main">
        <div class="logowrap">
          <img class="logo" src="../assets/image/logo/logo.svg" />
        </div>
      </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  // import引入的组件需要注入到对象中才能使用
  name:'h5tomp',
  components: {},
  data () {
    // 这里存放数据
    return {
      to:this.$route.query.to,
      id:this.$route.query.id
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

   this.getMpUrl();
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    getMpUrl(){
      let uuid='134';
      let path='';
   
      if(this.to=='custom'){
        path='pages/custom/index';
        uuid=this.id;
     
      }else if(this.to=='home'){
        path='pages/home/index'
      }else if(this.to=='pdp'){
        path='pages/goods/index';
        uuid=this.id;
      }else if(this.to=='20thplp'){
        path='galleryBook/pages/index/index';
      }else if(this.to=='20th'){
        path='/pages/middle/index';
      }else if(this.to=='homecollection'){
        path='HomeCollction/pages/index/index';
        
        this.$utils.trackData(this,'HomeCollction/pages/index/inde', "");
      }else if(this.to=='eyewear'){
        path='eyewear/pages/index/index';
        this.$utils.trackData(this,'eyewear/pages/index/inde', "");
       
      }else if(this.to=='tbsms'){
        path='/pages/middle/index';
      }
      else{
        path='packageSub/pages/chatail/index'
      }
     
      let query='';
      if(this.to=='20th'){
        this.$utils.trackData(this,'anniversary/pages/20th/index-mob', "");
        query='scene=' +'1cd684c3ee290d399705085ca63088c3'
      }else if(this.to=='tbsms'){
        this.$utils.trackData(this,'anniversary/pages/20th/index-sms', "");
        query='scene=' +'a154df9210adfa6ebbdb5b6968710148'
      } else{
        this.$utils.trackData(this,path, "");
        query='id=' + uuid
      }
   
      let url=this.$store.state.storeId=='54600421-438a-46e0-90db-4094e241d6ba'?'https://uat-auth.getconnectplus.com/url/link':'https://auth.getconnectplus.com/url/link';
      let params = {
        store_id:this.$store.state.storeId,
        path:path,
        query:query,
      };
      this.$http.post(url, this.$qs.stringify(params)).then(res => {
         if(res.data.errcode==0&&res.data.errmsg=='ok'){
            this.url_link=res.data.url_link;
            window.open(this.url_link);
            window.location.href =this.url_link;
         }
      })
    }
  }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.main{
  position: relative;
  width: 100%;
  height: 100vh;
}
 .logowrap{
    width: 10.8rem;
    height: 4.5rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    .logo{
      width: 100%;
      height: 100%;
    }
 }
</style>



// WEBPACK FOOTER //
// src/components/webtomp.vue